import { TravellerDetails } from '@/src/types/visa/visaItinerary'
import { UserProfileData } from '@/src/types/visa/userProfile'

export const createPrefilledTraveller = (
    userProfile: UserProfileData,
    traveller: TravellerDetails
): TravellerDetails => {
    return {
        ...traveller,
        personalDetails: {
            ...traveller.personalDetails,
            firstName: userProfile.firstName || traveller.personalDetails.firstName,
            lastName: userProfile.lastName || traveller.personalDetails.lastName,
            gender: userProfile.gender || traveller.personalDetails.gender,
            dateOfBirth: userProfile.dateOfBirth || traveller.personalDetails.dateOfBirth
        },
        passportDetails: {
            ...traveller.passportDetails,
            passportNumber: userProfile.passportNumber || traveller.passportDetails.passportNumber,
            expiryDate: userProfile.passportExpiry || traveller.passportDetails.expiryDate
        }
    }
}

export const shouldPreFillTraveller = (traveller: TravellerDetails): boolean => {
    return !traveller.personalDetails.firstName ||
           !traveller.personalDetails.lastName ||
           !traveller.personalDetails.gender
}

export const getPrefilledErrorFields = (
    userProfile: UserProfileData,
    currentErrors: Record<string, string>
): Record<string, string> => {
    const clearedErrors = { ...currentErrors }

    if (userProfile.firstName && clearedErrors.firstName) {
        clearedErrors.firstName = ''
    }
    if (userProfile.lastName && clearedErrors.lastName) {
        clearedErrors.lastName = ''
    }
    if (userProfile.gender && clearedErrors.gender) {
        clearedErrors.gender = ''
    }
    if (userProfile.dateOfBirth && clearedErrors.dateOfBirth) {
        clearedErrors.dateOfBirth = ''
    }
    if (userProfile.passportNumber && clearedErrors.passportNumber) {
        clearedErrors.passportNumber = ''
    }
    if (userProfile.passportExpiry && clearedErrors.expiryDate) {
        clearedErrors.expiryDate = ''
    }

    return clearedErrors
}

export const getPrefilledContactDetails = (
    userProfile: UserProfileData,
    currentContact: {
        customerEmail?: string
        phoneNumber?: string
        isdCode?: string
    }
) => {
    const cleanIsdCode = userProfile.isdCode?.replace(/^\+/, '') || currentContact.isdCode

    return {
        customerEmail: userProfile.email || currentContact.customerEmail,
        phoneNumber: userProfile.phoneNumber || currentContact.phoneNumber,
        isdCode: cleanIsdCode
    }
}

export const loadMobileCountryValidation = async (isdCode: string) => {
    try {
        const { MOBILE_COUNTRY_CODES } = await import('@/src/constants/visa/visaRequirements')
        const countryEntry = Object.entries(MOBILE_COUNTRY_CODES)
            .find(([_, countryData]) => countryData.code === isdCode)

        if (countryEntry) {
            const [countryKey, countryData] = countryEntry
            return {
                field: 'phoneNumber' as const,
                validation: {
                    minLength: countryData.min,
                    maxLength: countryData.max,
                    selectedMobileCountry: countryKey
                }
            }
        }
    } catch (error) {
        console.warn('Failed to load mobile country codes', error)
    }
    return null
}